import { render, staticRenderFns } from "./WorkRecordStatistics.vue?vue&type=template&id=51523748&scoped=true"
import script from "./WorkRecordStatistics.vue?vue&type=script&lang=js"
export * from "./WorkRecordStatistics.vue?vue&type=script&lang=js"
import style0 from "./WorkRecordStatistics.vue?vue&type=style&index=0&id=51523748&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51523748",
  null
  
)

export default component.exports